module.exports = __webpack_public_path__ + "static/media/setup_img3.9f75d8c3.png";